export * from './roles';
import { IS_ADMIN } from './validation';

export const COOKIE_AUTH_DETAILS = `${window?.$environment?.SERVICE_PROVIDER.toLocaleUpperCase()}${
  IS_ADMIN ? '_ADMIN' : ''
}_AUTH_DETAILS`;
export const COOKIE_CLIENT_AUTH_DETAILS = `${window?.$environment?.SERVICE_PROVIDER.toLocaleUpperCase()}${
  IS_ADMIN ? '_ADMIN' : ''
}_CLIENT_AUTH_DETAILS`;
export const COOKIE_FM_AUTH_DETAILS = `${window?.$environment?.SERVICE_PROVIDER.toLocaleUpperCase()}_AUTH_DETAILS`;
export const AUTH_TOKEN = 'token';
export const COOKIE_ENCRYPT_KEY = '123';
export const COOKIE_EXPIRY = 'Thu, 01 Jan 1970 00:00:00 UTC';

const handleGetPageUrls = (file) => {
  try {
    const pageUrls = require(`@/routes/${window?.$environment?.SERVICE_PROVIDER}/${file}`).default;
    return pageUrls;
  } catch (error) {
    return [];
  }
};

export const getPageUrls = (file) => {
  try {
    const pageUrls = require(`@/routes/web/${window?.$environment?.SERVICE_PROVIDER}/${file}`).default;
    return pageUrls;
  } catch (error) {
    const pageUrls = handleGetPageUrls(file);
    return pageUrls;
  }
};

const publicUrls = getPageUrls('publicConfig');
const privateUrls = getPageUrls('privateConfig');
const commonUrls = getPageUrls('commonConfig');

export const getUrls = (config) => {
  const result = config.map((item) => {
    return {
      [item.module]: item.url,
    };
  });
  return Object.assign({}, ...result);
};

export const urls = getUrls([...publicUrls, ...privateUrls, ...commonUrls]);

export const pageUrls = {
  ...urls,
  notFound: '/notfound',
};

export const periodList = [
  { label: 'Monthly', value: 'MONTHLY' },
  { label: 'Yearly', value: 'YEARLY' },
];

export const severityList = [
  {
    label: 'Less than 33%',
    value: 'LESS_THAN_33_PERCENTAGE',
  },
  {
    label: '33% to 67%',
    value: 'BETWEEN_33_TO_67_PERCENTAGE',
  },
  {
    label: 'Greater than 67%',
    value: 'GREATER_THAN_67_PERCENTAGE',
  },
  // commenting according to ticket FLEETMG-16582
  // {
  //   label: 'Speeding',
  //   value: 'SPEEDING'
  // },
  {
    label: 'Accident',
    value: 'ACCIDENT',
  },
  {
    label: 'Hard',
    value: 'HARD',
  },
  {
    label: 'Harsh',
    value: 'HARSH',
  },
  {
    label: 'Severe',
    value: 'SEVERE',
  },
];

export const recurrenceTypes = [
  { label: 'Does not repeat', value: 'NONE' },
  { label: 'One-Time', value: 'ONE_TIME' },
  { label: 'Recurring', value: 'RECURRING' },
];

export const recurrenceIntervals = [
  { label: 'Monthly', value: 'MONTHLY' },
  { label: 'Weekly', value: 'WEEKLY' },
  { label: 'Daily', value: 'DAILY' },
];

export const chartTypes = {
  BAR_CHART: 'barChartList',
  PIE_CHART: 'pieChartList',
  SCATTER_PLOT_CHART: 'scatterPlotList',
};

export const behaviourList = [
  {
    value: 'ACCELERATION',
    label: 'Acceleration',
  },
  {
    label: 'Accident',
    value: 'ACCIDENT',
  },
  {
    label: 'Braking',
    value: 'BRAKING',
  },
  {
    label: 'Radius',
    value: 'RADIUS',
  },
  {
    label: 'Turning',
    value: 'TURNING',
  },
];

export const externalUrls = {
  gs: {
    appStore: 'https://apps.apple.com/in/app/gorilla-safety-plus/id1641656287',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.gorillasafetyplus.eld',
  },
  clutch: {
    appStore: 'https://apps.apple.com/us/app/clutch-eld/id1524798260',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.clutch.eld',
  },
  radius: {
    appStore: 'https://apps.apple.com/us/app/eld-plus/id1545317178',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.cyntrx.eld',
  },
  edvir: {
    appStore: 'https://apps.apple.com/us/app/edvir/id1580685999',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.cyntrxedvir.eld',
  },
  riskTheory: {
    appStore: 'https://apps.apple.com/us/app/crm-fleet-intelligence/id1610680309',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.risktheory.eld',
  },
  at: {
    appStore: 'https://apps.apple.com/gb/app/all-ways-track-e-log/id1644829332',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.alwaystrack.eld',
  },
  eldx: {
    appStore: 'https://apps.apple.com/in/app/eld-x/id1641670475',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.gorilla.eldx',
  },
  simplex: {
    appStore: 'https://apps.apple.com/us/app/simplex-eld-2go/id6443451627?l=zh-Hans-CN',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.simplex.eld',
  },
  ft: {
    appStore: 'https://apps.apple.com/us/app/fleettrack-hos/id6444549255',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.fleettrack.eld',
  },
  hcss: {
    appStore: 'https://apps.apple.com/us/app/hcss-elogs-2022/id1658418335',
  },
  em: {
    appStore: 'https://apps.apple.com/gb/app/eld-mandate-pro/id1491823700',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.app.eldmandatepro',
  },
  spireon: {
    appStore: 'https://apps.apple.com/ec/app/fleetlocate-shift/id1278396252',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.app.fleetlocate',
  },
  tp: {
    appStore: 'https://apps.apple.com/gb/app/trucker-path-eld-pro/id1488420043',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.app.truckerpatheld',
  },
  trackon: {
    appStore: 'https://apps.apple.com/us/app/trackon-hos/id1241911012',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.app.trackon'
  },
};

export const AUTH_ROLES = {
  ADMIN: 'SUPER_ADMIN',
  RESELLER_ADMIN: 'RESELLER_ADMIN',
  SERVICE_MANAGER: 'SERVICE_MANAGER',
  SUPPORT: 'SUPPORT',
  RESELLER_EMPLOYEE: 'Reseller Employee',
};

export const COMPANY_TYPES = {
  ...(window.$environment?.SERVICE_PROVIDER === 'edvir'
    ? {
        Fleet: 'FLEET',
        'Service Center': 'Service_Center',
      }
    : {}),
  ...(window.$environment?.SERVICE_PROVIDER === 'riskTheory'
    ? {
        'Policy Holder': 'FLEET',
        MGA: 'Insurance',
      }
    : {}),
};

export const cameraTypeList = {
  waylens360: "Waylens 360",
  waylensAirII: "Waylens Air II",
  geometris: "Geometris"
};
